
import Vue from 'vue'
export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      checkbox: false
    }
  },
  watch: {
    checkbox: function(value: any) {
      const { prefix: prefix1, key: key1 } = this.parent._getPrefixAndKey(this.input.variable);
      const initialData = this.getVariable(prefix1);
      const { prefix, key } = this.parent._getPrefixAndKey(prefix1);
      this.$set(this.getVariable(prefix), key, { ...initialData, [key1]: value });
      if(this.input.onChange) {
        this.parent._callMultipleFunctions(this.input.onChange);
      }
    } 
  },
  mounted() {
    this.$watch(
      () => this.parent._getVariable(this.input.variable), 
      (checkboxVariable) => {
        this.checkbox = checkboxVariable || false;
      },
      { immediate: true }
    )
  }
})
